<template>
  <div class="modal-template" :class="{ active: show }">
    <div class="modal" v-if="modal">
      <div class="name-template">{{ modal.group_name }}</div>
      <div class="scroll">
        <div
          class="content-info"
          v-for="question in modal.questions"
          :key="question.code"
        >
          <span>{{ typeOptions[question.type] }}</span>

          <div class="questions">
            <p>{{ question.question }}</p>

            <div v-if="question.type === questionTypes.number">
              <input class="input-number" type="number" min="0" />
            </div>

            <div
              v-if="
                question.type === questionTypes.text ||
                  question.type === questionTypes.message
              "
            >
              <textarea class="text-area" cols="30" rows="3"></textarea>
            </div>

            <div v-if="question.answers.length">
              <p class="answer-type">
                Answer
              </p>
              <div
                class="answers"
                v-for="(answers, index) in question.answers"
                :key="index"
              >
                <div
                  class="type-question"
                  v-if="
                    question.type === questionTypes.radio ||
                      question.type === questionTypes.matrixRadio ||
                      question.type === questionTypes.ranking
                  "
                >
                  <input type="radio" :name="`ans${question.code}`" />
                  <label>{{ answers.label }}</label>
                </div>
                <div
                  class="type-question"
                  v-if="question.type === questionTypes.checkbox"
                >
                  <input type="checkbox" name="ans" />
                  <label>{{ answers.label }}</label>
                </div>
              </div>
            </div>

            <div class="marginSub" v-if="question.subQuestions.length">
              <p class="answer-type">
                Sub Questions
              </p>
              <div
                class="answers"
                v-for="(sub, index) in question.subQuestions"
                :key="index"
              >
                <div
                  class="type-question"
                  v-if="
                    question.type === questionTypes.radio ||
                      question.type === questionTypes.matrixRadio
                  "
                >
                  <input type="radio" :name="`sub${question.code}`" />
                  <label>{{ sub.label }}</label>
                </div>

                <div
                  class="type-question"
                  v-if="
                    question.type === questionTypes.multiNumber ||
                      question.type === questionTypes.matrixCheckbox
                  "
                >
                  <input type="checkbox" name="ans" />
                  <label>{{ sub.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <button class="close-modal" @click="closeModal">
          {{ parseTranslation(CLOSE) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { TYPE_OPTIONS, QUESTION_TYPES } from '@/utils/constants'

import * as translationTemplateGroups from './TemplateGroups.translations'

const { default: translations, ...translationKeys } = translationTemplateGroups

export default {
  data() {
    return {
      translations,
      ...translationKeys,
      show: false,
      typeOptions: TYPE_OPTIONS,
      questionTypes: QUESTION_TYPES,
    }
  },
  computed: {
    modal() {
      return this.$store.getters.modalTemplate
    },
  },
  watch: {
    modal() {
      if (this.modal) {
        this.openModal()
      }
    },
  },
  methods: {
    ...mapActions(['modalTemplate']),

    openModal() {
      this.show = true
    },

    closeModal() {
      this.show = false
      this.modalTemplate(null)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-template {
  animation: show 0.5s forwards;
  display: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  background: $transparent;
  &.active {
    display: block;
  }

  .modal {
    width: 80%;
    height: 90%;
    padding: 20px 5px 20px 20px !important;
    background: $main-4;
    position: fixed;
    top: 5%;
    left: 10%;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);

    .name-template {
      width: calc(100% - 15px);
      margin-right: 15px;
      padding: 15px 20px;
      margin-bottom: 5px;
      background: $blue-3;
      border-radius: 10px;
      @include typography1(18, 21, $white, 900);
      text-transform: uppercase;
    }

    .scroll {
      height: 83%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 5px;
        position: absolute;
        right: 0;
      }
      &::-webkit-scrollbar-track {
        background: $gray-6;
        position: absolute;
        right: 0;
      }
      &::-webkit-scrollbar-thumb {
        background: $gray-7;
        border-radius: 5px;
        position: absolute;
        right: 0;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: $gray-8;
        position: absolute;
        right: 0;
      }
      .light & {
        border-right: 1px solid $gray-5;
        &::-webkit-scrollbar-track {
          background: $white-3;
        }
        &::-webkit-scrollbar-thumb {
          background: $gray-12;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: $gray-11;
        }
      }

      .content-info {
        width: 100%;
        padding: 20px;
        span {
          @include typography1(13, 21, $white, 500);
        }

        .questions {
          margin-top: 15px;
          width: 100%;
          height: auto;
          padding: 10px;
          border: 2px solid $gray-light-5;
          background: $main-two;
          border-radius: 8px;
          p {
            @include typography1(13, 16, $white, 400);
            margin-bottom: 15px;
          }

          .answer-type {
            font-weight: bold;
            margin-left: 5px;
          }

          .input-number {
            display: block;
            background: none;
            border: 1px solid $gray-9;
            border-radius: 3px;
            padding: 4px 5px;
            margin: 0 8px;
            max-width: 60px;
            @include tipography(14);
            &:focus {
              outline: none;
              border: 1px solid $white;
            }
          }

          .text-area {
            border: 1px solid $gray-9;
            border-radius: 3px;
            padding: 4px 5px;
            width: 100%;
            background: $main-4;
            @include tipography(14);
            &:focus {
              outline: none;
              border: 1px solid $white;
            }
          }

          .answers {
            margin: 10px 0px;
            .type-question {
              label {
                margin-left: 5px;
                @include typography1(13, 15, $white, 400);
              }
            }
          }

          .marginSub {
            margin-top: 20px;
          }
        }
      }
    }
    .btn {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: 20px;
      right: 15px;

      .close-modal {
        margin-right: 20px;
        background: $main;
        @include typography1(13, 15, $gray-2, 600);
        color: $white;
        border: none;
        border-radius: 3px;
        text-transform: uppercase;
        letter-spacing: 0.2em;
        // text-align: center;
        padding: 7px 20px;
        cursor: pointer;
        width: 105px;
      }
    }
  }
  .light & {
    background: $transparent;

    .modal {
      background: $gray-light-3;
      p {
        @include typography1(13, 21, $gray-6, 500);
      }

      .name-template {
        background: $blue-3;
        @include typography1(18, 21, $white, 900);
      }

      .content-info {
        span {
          @include typography1(13, 21, $gray-6, 500);
        }

        .questions {
          background: $white;
          p {
            @include typography1(13, 16, $gray-6, 400);
          }

          .input-number {
            color: $gray-6;
            &:focus {
              outline: none;
              border: 1px solid $gray-8 !important;
            }
          }

          .text-area {
            color: $gray-6;
            background: $white;
            &:focus {
              outline: none;
              border: 1px solid $gray-8;
            }
          }

          .answers {
            .type-question {
              label {
                @include typography1(13, 15, $gray-2, 400);
              }
            }
          }
        }
      }
    }
  }
}
</style>
